import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useCustomerValue } from "providers/CustomerContext";
import { ListLayout, TableCard } from "ui-components/Layout";
import { Error_, LoadingDialog } from "ui-components/Alert";
import BasicTable from "ui-components/tables/BasicTable";
import MDBox from "components/MDBox";
import { getReturnOrderWebApiList } from "services/data.outbound.service";
import ReturnOrderWebApiLog from "./components/ReturnOrderWebApiLog";

function ReturnOrderWebApi() {
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const [open, setOpen] = useState(false);
  const [logRequest, setLogRequest] = useState(null);
  const logProp = { open, setOpen, logRequest, setLogRequest };

  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const { data, isFetching } = useQuery({
    queryKey: ["return-order-webapi", { customerCode }],
    queryFn: () => getReturnOrderWebApiList({ customerCode }),
    enabled: Boolean(customerCode),
    select: (res) => res.data.data,
    onError,
  });

  // click a row's number to open the details of that return order
  const LinkCell = ({ row, field }) => {
    const { custOrdNbr, returnNumber } = row.original;
    return (
      <span
        style={{ color: "#1A73E8", cursor: "pointer", textDecoration: "underline" }}
        onClick={() => {
          setOpen(true);
          setLogRequest({ customerCode, returnNumber, custOrdNbr });
        }}
      >
        {row.original[field] || "-"}
      </span>
    );
  };

  const columns = [
    {
      accessorKey: "custOrdNbr",
      header: "Cust Order Number",
      cell: (props) => <LinkCell {...props} field="custOrdNbr" />,
    },
    {
      accessorKey: "returnNumber",
      header: "Return Number",
      cell: (props) => <LinkCell {...props} field="returnNumber" />,
    },
    { accessorKey: "orderNumber", header: "Order Number" },
    { accessorKey: "trackingNumber", header: "Tracking Number" },
    { accessorKey: "carrier", header: "Carrier" },
    { accessorKey: "lineCount", header: "SKU Lines" },
    { accessorKey: "orderQuantity", header: "Order Quantity" },
    { accessorKey: "cancelQuantity", header: "Cancel Quantity" },
    { accessorKey: "createdBy", header: "Created By" },
    { accessorKey: "createdOn", header: "Created On" },
  ];

  return (
    <>
      <ReturnOrderWebApiLog {...logProp} />
      <ListLayout>
        {isFetching && <LoadingDialog />}
        <MDBox mt={3} mb={1}>
          {alert}
        </MDBox>
        <TableCard sx={{ marginTop: 1 }}>
          <BasicTable data={data ?? []} columns={columns} />
        </TableCard>
      </ListLayout>
    </>
  );
}

export default ReturnOrderWebApi;
